// =============================================================================
// Child theme entry — client-specific behaviors.
// =============================================================================

// The Yuan header uses backdrop-filter, which makes it the containing block for
// position: fixed descendants and clips the mini-cart drawer to the header's
// height. Portal each drawer to <body> after the parent's mini-cart module
// (initialised on DOMContentLoaded) has captured its element references, and
// mirror the root's state classes onto the drawer for the open/busy styles.
const MINI_CART_STATE_CLASSES = ["az-mc--open", "az-mc--busy"];

const portalMiniCartDrawers = () => {
	document.querySelectorAll(".az-mc--drawer").forEach((root) => {
		const drawer = root.querySelector(".az-mc__drawer");
		if (!drawer) {
			return;
		}

		drawer.dataset.side = root.dataset.side || "right";
		document.body.append(drawer);

		const syncState = () => {
			MINI_CART_STATE_CLASSES.forEach((name) => {
				drawer.classList.toggle(name, root.classList.contains(name));
			});
		};

		syncState();
		new MutationObserver(syncState).observe(root, { attributes: true, attributeFilter: ["class"] });
	});
};

const deferPastParentInit = () => window.setTimeout(portalMiniCartDrawers, 0);

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", deferPastParentInit);
} else {
	deferPastParentInit();
}

const contactForms = document.querySelectorAll(".yuan-contact-form[data-ajax-url]");

const showContactError = (form, message) => {
	const existingAlert = form.parentElement?.querySelector(".yuan-form-alert");
	existingAlert?.remove();

	const alert = document.createElement("div");
	alert.className = "yuan-form-alert";
	alert.dataset.yuanAjaxAlert = "true";
	alert.setAttribute("role", "alert");
	alert.setAttribute("tabindex", "-1");
	alert.textContent = message;
	form.before(alert);
	alert.focus({ preventScroll: true });
	alert.scrollIntoView({ behavior: "smooth", block: "nearest" });
};

contactForms.forEach((form) => {
	form.addEventListener("submit", async (event) => {
		if (typeof window.fetch !== "function" || typeof window.FormData !== "function") {
			return;
		}

		const ajaxUrl = form.dataset.ajaxUrl;
		const submitButton = form.querySelector('button[type="submit"]');

		if (!ajaxUrl || !submitButton || submitButton.disabled) {
			return;
		}

		event.preventDefault();
		form.parentElement?.querySelector(".yuan-form-alert")?.remove();

		const originalButtonHtml = submitButton.innerHTML;
		submitButton.disabled = true;
		submitButton.textContent = "Submitting…";
		form.setAttribute("aria-busy", "true");

		try {
			const response = await fetch(ajaxUrl, {
				method: "POST",
				body: new FormData(form),
				credentials: "same-origin",
				headers: {
					Accept: "application/json",
				},
			});
			const payload = await response.json();

			if (!response.ok || !payload.success || !payload.data?.html) {
				const message = payload.data?.message
					|| "We could not submit your request. Please try again.";
				showContactError(form, message);
				return;
			}

			const card = form.closest(".yuan-form-card");
			if (!card) {
				window.location.assign(form.action);
				return;
			}

			card.innerHTML = payload.data.html;
			const result = card.querySelector(".yuan-form-result");
			const resetLink = result?.querySelector(".yuan-button[href]");
			if (resetLink && typeof window.history.replaceState === "function") {
				window.history.replaceState({}, "", resetLink.href);
			}
			result?.focus({ preventScroll: true });
			result?.scrollIntoView({ behavior: "smooth", block: "nearest" });
		} catch {
			showContactError(
				form,
				"We could not submit your request. Please check your connection and try again.",
			);
		} finally {
			if (form.isConnected) {
				form.removeAttribute("aria-busy");
				submitButton.disabled = false;
				submitButton.innerHTML = originalButtonHtml;
			}
		}
	});
});
